import React from 'react'
import { Field, FieldArray, FieldProps } from 'formik'
import { useServiceContext } from '../../../../../root'
import { WF_STEP_TYPE } from './constants'
import UserGroupSteps from './UserGroupSteps'

interface ReviewStepFormProps {
  values: any
  setFieldValue: (field: string, value: any) => void
}

const ReviewStepForm: React.FC<ReviewStepFormProps> = ({ values, setFieldValue }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const reviewersType = values.reviewers?.type || WF_STEP_TYPE.NOT_DEFINED

  return (
    <>
      <div className="form-group">
        <label className="control-label">{translate('BROWSER_FILE_SETTINGS_REVIEWERS_TYPE_HEADLINE')}</label>
        <Field name="reviewers.type">
          {({ field }: FieldProps) => (
            <>
              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`a8282512-d602-424a-95d0-e927862e4add-${WF_STEP_TYPE.NOT_DEFINED}`}
                    value={WF_STEP_TYPE.NOT_DEFINED}
                    checked={reviewersType === WF_STEP_TYPE.NOT_DEFINED}
                    onChange={() => setFieldValue('reviewers.type', WF_STEP_TYPE.NOT_DEFINED)}
                  />
                  {translate('BROWSER_FILE_SETTINGS_REVIEWERS_LABEL_NOT_DEFINED')}
                </label>
              </div>
              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`a8282512-d602-424a-95d0-e927862e4add-${WF_STEP_TYPE.SETUP_WITH_WORKFLOW}`}
                    value={WF_STEP_TYPE.SETUP_WITH_WORKFLOW}
                    checked={reviewersType === WF_STEP_TYPE.SETUP_WITH_WORKFLOW}
                    onChange={() => setFieldValue('reviewers.type', WF_STEP_TYPE.SETUP_WITH_WORKFLOW)}
                  />
                  {translate('BROWSER_FILE_SETTINGS_REVIEWERS_LABEL_SETUP_REVIEWERS_WITH_CR')}
                </label>
              </div>
              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`a8282512-d602-424a-95d0-e927862e4add-${WF_STEP_TYPE.USE_PREDEFINED}`}
                    value={WF_STEP_TYPE.USE_PREDEFINED}
                    checked={reviewersType === WF_STEP_TYPE.USE_PREDEFINED}
                    onChange={() => setFieldValue('reviewers.type', WF_STEP_TYPE.USE_PREDEFINED)}
                  />
                  {translate('BROWSER_FILE_SETTINGS_REVIEWERS_LABEL_USE_PREDEFINED')}
                </label>
              </div>
            </>
          )}
        </Field>
      </div>
      {/* Show UserGroupSteps when USE_PREDEFINED is selected */}
      {reviewersType === WF_STEP_TYPE.USE_PREDEFINED && (
        <UserGroupSteps
          name="reviewers.steps"
          values={values.reviewers?.steps || []}
          labelTxt={'BROWSER_FILE_SETTINGS_REVIEWERS_REVIEW_SEQUENCE_HEADLINE'}
          nofallTxt={'BROWSER_FILE_SETTINGS_REVIEWERS_INFO_LABEL'}
        />
      )}
    </>
  )
}

export default ReviewStepForm
